'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _tslib = require('../../_virtual/_tslib.js');
var jsxRuntime = require('react/jsx-runtime');
var React = require('react');
var formik = require('formik');
var Select$1 = require('react-select');
var useDocument = require('../../hooks/useDocument.js');
var customComponents = require('./customComponents.js');
var customStyles = require('./customStyles.js');
var utils = require('./utils.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var Select__default = /*#__PURE__*/_interopDefaultLegacy(Select$1);

var Select = function (_a) {
    var _b = _a.components, componentsProp = _b === void 0 ? {} : _b, id = _a.id, name = _a.name, onBlurCallback = _a.onBlur, onChangeCallback = _a.onChange, _c = _a.options, selectOptions = _c === void 0 ? [] : _c, _d = _a.styles, stylesProp = _d === void 0 ? {} : _d, rest = _tslib.__rest(_a, ["components", "id", "name", "onBlur", "onChange", "options", "styles"]);
    var _e = formik.useField(name), _f = _e[1], error = _f.error, touched = _f.touched, value = _f.value, _g = _e[2], setTouched = _g.setTouched, setValue = _g.setValue;
    var doc = useDocument["default"]();
    var handleBlur = function (evt) {
        if (!touched) {
            // Timout because of race condition bug in Formik: https://github.com/formium/formik/issues/2457
            setTimeout(function () { return setTouched(true); }, 0);
        }
        if (onBlurCallback) {
            onBlurCallback(evt);
        }
    };
    var onChange = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var fieldValue = args[0];
        var newVal;
        if (fieldValue && 'value' in fieldValue) {
            newVal = fieldValue.value;
        }
        else if (fieldValue === null) {
            newVal = '';
        }
        setValue(newVal);
        if (onChangeCallback) {
            onChangeCallback.apply(void 0, args);
        }
    };
    var options = selectOptions || [];
    var flattenedOptions = utils.flattenOptions(options);
    var selectedItem = React.useMemo(function () { return flattenedOptions.find(function (_a) {
        var optionValue = _a.value;
        return optionValue === value;
    }); }, [flattenedOptions, value]);
    return (jsxRuntime.jsx(Select__default["default"], _tslib.__assign({ blurInputOnSelect: true, components: _tslib.__assign({ ClearIndicator: customComponents.ClearIndicator, DropdownIndicator: customComponents.DropdownIndicator, MultiValueRemove: customComponents.MultiValueRemove }, componentsProp), inputId: id, menuPortalTarget: doc ? doc.body : undefined, onBlur: handleBlur, onChange: onChange, options: options, styles: _tslib.__assign(_tslib.__assign({}, customStyles["default"]), stylesProp), value: selectedItem, touched: touched, error: error }, rest)));
};

exports["default"] = Select;
//# sourceMappingURL=Select.js.map
